import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const InfoModal = ({ modal, setModal }) => {
  const handleClose = () => {
    setModal({ ...modal, info: false });
  };

  return (
    <div>
      <Modal isOpen={modal.info} className="modal-dialog" role="document">
        <ModalHeader className="bg-primary">{"Información"}</ModalHeader>
        <ModalBody>
          <p>Esta es la información</p>
        </ModalBody>
        <ModalFooter>
          {/* {edit && (
            <Button color="primary" onClick={save} disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fa fa-save"></i> Guardar Cambios
            </Button>
          )}
          {branch?.positions?.length > 0 && (
          <Button
            color="primary"
            onClick={() => updateGeofences()}
            disabled={loadingUpdateGeo}
          >
            {loadingUpdateGeo && <Spinner size="sm"></Spinner>}{" "}
            <i className="fa fa-sync"></i> Update Geofences
          </Button>
          )} */}
          <Button color="secondary" onClick={handleClose}>
            <i className="fa fa-times"></i> Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default InfoModal;
